import { render, staticRenderFns } from "./WidgetStructureSummary.vue?vue&type=template&id=32bbfb9e&"
import script from "./WidgetStructureSummary.vue?vue&type=script&lang=js&"
export * from "./WidgetStructureSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports